module.exports = __webpack_public_path__ + "img/2048.e9f84b3c.svg";